// Hash routing: the public route shapes are frozen (backend redirect targets for
// printed QR codes). See docs/caller-flow-contract.md. The /staff group is the staff
// web softphone (roadmap #41), rehomed here from the old frontend.
import { HashRouter, Route, Routes } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import ScanLanding from './screens/ScanLanding'
import CallScreen from './screens/CallScreen'
import CallEnded from './screens/CallEnded'
import StaffNotAvailable from './screens/StaffNotAvailable'
import CallbackOnPhone from './screens/CallbackOnPhone'
import CallError from './screens/CallError'
import InvalidQr from './screens/InvalidQr'
import PrivacyPolicy from './screens/legal/PrivacyPolicy'
import DeleteAccount from './screens/legal/DeleteAccount'
import Contact from './screens/legal/Contact'
import Landing from './screens/legal/Landing'
import StaffLogin from './staff/StaffLogin'
import StaffDashboard from './staff/StaffDashboard'
import StaffIncomingCall from './staff/StaffIncomingCall'
import StaffCall from './staff/StaffCall'
import RequireStaffAuth from './staff/RequireStaffAuth'

// The staff session is established by the single sign-on check when the /staff
// screen mounts (see staff/StaffLogin + staff/staffAuth). The public guest
// caller never contacts the identity provider.

const App = () => {
  return (
    <HashRouter>
      <Toaster position="top-center" />
      <Routes>
        {/* PUBLIC CALLER FLOW */}
        <Route path="/user-scan-qrcode/:token/:detailsToken" element={<ScanLanding />} />
        <Route path="/calling" element={<CallScreen />} />
        <Route path="/thanks-call" element={<CallEnded />} />
        <Route path="/staffnotavailable" element={<StaffNotAvailable />} />
        {/* Reached by scanning the code shown on a keyboard-less public screen, from
            the guest's own phone (roadmap #61). New route, not one of the frozen ones. */}
        <Route path="/callback/:callId" element={<CallbackOnPhone />} />
        <Route path="/callErrorHandler" element={<CallError />} />
        <Route path="/invalid-qr" element={<InvalidQr />} />

        {/* PUBLIC STATIC / LEGAL PAGES — frozen URLs rehosted from the legacy
            frontend (app-store listings, mobile app and emails point here). */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/content/view/content-howtodeleteaccount" element={<DeleteAccount />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/start" element={<Landing />} />

        {/* STAFF WEB SOFTPHONE (roadmap #41) */}
        <Route path="/staff" element={<StaffLogin />} />
        <Route
          path="/staff/dashboard"
          element={
            <RequireStaffAuth>
              <StaffDashboard />
            </RequireStaffAuth>
          }
        />
        <Route
          path="/staff/incomingcall"
          element={
            <RequireStaffAuth>
              <StaffIncomingCall />
            </RequireStaffAuth>
          }
        />
        <Route
          path="/staff/callcomponent"
          element={
            <RequireStaffAuth>
              <StaffCall />
            </RequireStaffAuth>
          }
        />

        <Route path="*" element={<InvalidQr />} />
      </Routes>
    </HashRouter>
  )
}

export default App
